// Base annotation tool definitions for the modern review screen. Shared by the
// tools dropdown (proof-view-new-annotations) and the per-file-type default-tool
// logic in proofView.v2 so the tool objects stay identical in both places.
export function getAnnotationToolTypes(getLabel) {
  return [
    {
      docTypes: ["document", "video", "image", "html", "web_url"],
      type: "point",
      title: () => getLabel("review_screen_labels", "anno_single_click"),
      image: "/img/icon-doubleclick.svg",
      cursor: "/img/icon-doubleclick.png",
    },
    {
      docTypes: ["document", "video", "image", "html", "web_url"],
      type: "rect",
      title: () => getLabel("review_screen_labels", "anno_rect"),
      image: "/img/icon-rectangle.svg",
      cursor: "/img/icon-rectangle.png",
    },
    {
      docTypes: ["document", "video", "image", "html", "web_url"],
      type: "arrow",
      title: () => getLabel("review_screen_labels", "anno_arrow"),
      image: "/img/icon-arrow.svg",
      cursor: "/img/icon-arrow.png",
    },
    {
      docTypes: ["document", "video", "image", "html", "web_url"],
      type: "draw",
      title: () => getLabel("review_screen_labels", "anno_draw"),
      image: "/img/draw.svg",
      cursor: "",
    },
  ];
}

// Maps a file's docTypeGroup to the key used in the account-level
// defaultAnnotationTools setting (html and web_url share one "web" preference).
export function annotationToolKeyForDocType(docTypeGroup) {
  if (docTypeGroup === "html" || docTypeGroup === "web_url") return "web";
  return docTypeGroup;
}
